<template>
    <tr class="p-grid p-col-12">
        <td  class="p-col">
            <h3>
            {{lesson.hebrewName}}
            </h3>
        </td>

        <th class="p-col" v-for="day in days">
            <schedule-item isMultipleAllow="isMultipleAllow"  @deleteSchedule="deleteSchedule" :deleteMode="deleteMode" :date="getDate(day)" :showReport="showReport" :studyTeacher="studyTeacher  && studyTeacher[day.id] " :loading="loading" :teacher="teacher" :day="day" :lesson="lesson" :schedule="getRowScheduleValue(day.id)" />
        </th>

    </tr>
</template>

<script>
import {mapState} from "vuex";
import ScheduleItem from "@/views/Schedule/ScheduleTeacher/ScheduleItem";
import {days} from "@/views/Schedule/Schedule";
import {toFullHebrewWeekRange} from "@/utils/hebrewDateFormat";

export default {
    name: "TeacherRowSchedule",
    components: {
        ScheduleItem,
    },
    props: {
        lesson: {
            type: Object,
            default: null,
        },
        isMultipleAllow: {
            type: Boolean,
            default: false,
        },
        teacher: {
            type: String,
            default: null,
        },
        rowScheduleValue: {
            type: Object,
            default: null
         },
        studyTeacher: {
            type: Object,
            default: null
         },
        weekSelected: {
            type: Object,
            default: null
         },
        loading: {
            type: Boolean,
            default: false
        },
        showReport: {
            type: Boolean,
            default: false
        },
        deleteMode: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        rowScheduleValue(newValue, oldValue) {
            this.$forceUpdate()
        }
    },
    computed: {

        ...mapState(["lessonTime", "subjectLesson"]),
    },
    methods: {
        deleteSchedule(event){
            this.$emit('deleteSchedule', event);
        },
        getDate(day){
           const dateObj = new Date(this.weekSelected?.firstDay)
            const add = day.value
            dateObj.setDate(dateObj.getDate() + add)

return dateObj
        },
        getRowScheduleValue(dayId){
            if (this.rowScheduleValue !== null){
                return this.rowScheduleValue[dayId]
            }
            return {}
        },
    },
    data() {
        return {
            days
        }
    },
}

</script>

<style scoped>
h3{
    text-align: center !important;
    vertical-align: middle;
}
td{
    background: #d7fcfb;
    display: flex;
    align-items: center;
    justify-content: center
}
th{

}
</style>